import { Component, Input, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, of, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ComPromoterCategoryModel } from 'src/app/model/com-promoter-category.model';
import { CatalogModel } from 'src/app/model/other-catalogs-models';
import { CatCategoryPromoterService } from 'src/app/services/cat-category-promoter.service';
import { CatEmployeeJobService } from 'src/app/services/cat-employee-job.service';
import { ComPromoterCategoryService } from 'src/app/services/com-promoter-category.service';

@Component({
  selector: 'app-modal-sc-promoter-category',
  templateUrl: './modal-sc-promoter-category.component.html',
  styleUrls: ['./modal-sc-promoter-category.component.css']
})
export class ModalScPromoterCategoryComponent implements OnInit {
  @Input() category:ComPromoterCategoryModel;
  @Input() page:string;
  @Input() mode:string;

  // estado pagina
  public viewStatus:number=1;
  public formIsLocked:boolean=false;

  // catalogos
  public categoryPromoterCatalog:CatalogModel[]=[];
  public employeeJobCatalog:CatalogModel[]=[];

  // mascaras
  public customPatterns={
    'A':{pattern:new RegExp('[a-zA-Z0-9ñÑ ]')},                     // inputs regulares
    'C':{pattern:new RegExp('[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ,._:%\/() \-]')},       // comentarios (acepta acentos, comas y puntos)
    'N':{pattern:new RegExp('[0-9]')} 
  };

  /////////////////
  constructor(
    private catPromoterCategoryService:CatCategoryPromoterService,
    private catEmployeeJobService:CatEmployeeJobService,
    private comPromoterCategoryService:ComPromoterCategoryService,
    private modalService: NgbModal,
    private toastr:ToastrService
  ) { }
  ngOnInit() {
    this.getCatalogs();
  }

  //
  updatePromoterCategory=()=> {}
  updateEmployeeJob=()=> {}
  updatePaymentType=()=> {}
  updateMinCollect=e=> this.category.minCollectAmount=Number(e);
  updateMaxCollect=e=> this.category.maxCollectAmount=Number(e);
  toggleActive=()=> this.category.activeId=!this.category.activeId;
  isValid=()=> {
    let valid=true;
    let errors=[];
    if(this.promoterCategoryError()) errors.push('Necesita seleccionar una categoría.');
    if(this.employeeJobError()) errors.push('Necesita seleccionar un puesto.');
    if(this.minCollectError()) errors.push('Necesita capturar un cobro mínimo.');
    if(this.maxCollectError()) errors.push('Necesita capturar un cobro máximo.');
    if(this.minCollectMayorError()) errors.push('El cobro mínimo no puede ser mayor al cobro máximo.');
    if(errors.length>0) {
      valid=false;
      this.toastr.error(errors.join('<br>'), '¡Atención!', {enableHtml:true});
    }
    return valid;
  }
  save=()=> {
    if(this.isValid()) {
      // mostrar spinner
      this.viewStatus=0;
      // enviar informacion
      this.comPromoterCategoryService.save(this.category)
        .pipe(
          tap((resp:any)=> {
            console.log(resp);
            this.modalService.dismissAll('success');
            this.toastr.success('La categoría se guardó con éxito.');
          }),
          catchError((error: HttpErrorResponse)=> {
            console.log(error);
            this.viewStatus = 1;
            const body = error && error.error;
            if (error && error.status === 409 && body && body.codeHttpStatus === 409) {
              // combinación categoría+puesto duplicada: mensaje real del backend, no genérico, y el modal se queda abierto
              this.toastr.warning(body.messageError, '¡Atención!');
            } else {
              this.toastr.error((body && body.messageError) || 'Ocurrió un error al intentar guardar la categoría.', '¡Atención!');
            }
            return of(null);
          })
        )
        .subscribe();
    }
  }
  close=()=> this.modalService.dismissAll();

  // HELPERS
  promoterCategoryError=()=> !this.category.promoterCategoryId;
  employeeJobError=()=> !this.category.employeeJobId;
  minCollectError=()=> this.category.minCollectAmount<0 && !this.category.minCollectAmount; //isNullOrUndefined(this.category.minCollectAmount);
  maxCollectError=()=> this.category.maxCollectAmount!==0 && !this.category.maxCollectAmount;
  minCollectMayorError=()=> this.category.minCollectAmount > this.category.maxCollectAmount;

  // INFO
  getCatalogs=()=> {
    forkJoin(
      this.catPromoterCategoryService.catalog(),
      this.catEmployeeJobService.catalog()
    )
    .pipe(
      tap(([catPromoResp, catEmpJobResp]:[any, any])=> {
        if(catPromoResp && catEmpJobResp) {
          this.categoryPromoterCatalog=catPromoResp.data;
          this.employeeJobCatalog=catEmpJobResp.data;
          console.log(this.categoryPromoterCatalog)
          this.viewStatus=1;
        }
        else throwError;
      }),
      catchError(error=> {
        console.log(error);
        this.viewStatus=-1;
        return of(this.toastr.error('Ocurrió un error al leer los catálogos.'));
      })
    )
    .subscribe();
  }
}